import React, { useState } from 'react';

// Components //
import TitleSection from "../../molecules/title-section";
import DocumentCard from '../../molecules/document-card/DocumentCard';

// Interfaces //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles
import "./RequiredDocuments.scss";

const RequiredDocuments = (props: ReferenciaContenido) => {
    const [videoUrl, setVideoUrl] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const {tituloGeneral, referenciaPlantillaContenido: documentsList} = props;

    const onShowModal = (value: string) => {
        setIsOpen(!isOpen);
        setVideoUrl(value);
    }

    return (
        <div className="o-required-documents">
            <div className="container">
                <div className="o-required-documents__inner">
                    <TitleSection title={tituloGeneral}/>
                    <div className="o-required-documents__items">
                        {documentsList.map((item) => (
                            <DocumentCard 
                                key={item.titulo} 
                                title={item.tituloBanner} 
                                description={item.descripcion} 
                                image={item.imagenPrincipal[0].file.url}
                                buttonLabel={item.tituloBoton}
                                documentLink={item.documentos}
                                videoLink={item.redireccionBoton && item.redireccionBoton}
                                onShowModal={onShowModal}
                                tipo={props.descripcionFija}
                            />
                        ))}
                    </div>
                </div>
            </div>
            {isOpen && (
                <div className="modal">
                    <span className="icon-close" onClick={() => setIsOpen(false)}></span>
                    <div className="modal__content">
                        <iframe
                            src={videoUrl}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                        </iframe>  
                    </div>
                </div>
            )}
        </div>
    )
}

export default RequiredDocuments